export const CONTACT_DATA = "CONTACT_DATA";
export const TOUCH_DATA = "TOUCH_DATA";
export const QUOTE_DATA = "QUOTE_DATA";
export const PRODUCT_LIST_DATA = "PRODUCT_LIST_DATA";
export const PRODUCT_DETAILS_DATA = "PRODUCT_DETAILS_DATA";
export const PRODUCT_DETRAIL = "PRODUCT_DETRAIL";

export const FOOTER_INDESTRY_LIST_DATA="FOOTER_INDESTRY_LIST_DATA"